export const comfortRangeConfig = {
  too_little_risk: 'Too Little Risk',
  marginal_lower: 'Marginal Lower',
  ok_risk: 'OK Risk',
  marginal_upper: 'Marginal Upper',
  too_much_risk: 'Too Much Risk'
} as any;
